<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY <br/></span>A<span class="smallcaps">NDREW </span>M<span class="smallcaps">ILLER</span></h1>
<p class="center"><em class="italic">Pure</em></p>
<p class="center"><em class="italic">The Crossing</em></p>
<p class="center"><em class="italic">Now We Shall Be Entirely Free</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-slowworm-song_00000.vue?7a156b60